var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiggestMoversVolume({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15F1CB68-11E5-421F-83F6-71D4B1A462E9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-378.000000, -2270.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-2",
    transform: "translate(378.000000, 2270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 72.2446154,
    x2: 235,
    y2: 72.2446154,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 41.6646154,
    x2: 235,
    y2: 41.6646154,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 102.824615,
    x2: 235,
    y2: 102.824615,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(55.874000, 19.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E5E6E5",
    points: "16 91.3301 11 3.3301 5 3.3301 0 91.3301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.657,96.65675 C16.781,93.53275 16.781,88.46775 13.657,85.34375 C10.532,82.21875 5.468,82.21875 2.343,85.34375 C-0.781,88.46775 -0.781,93.53275 2.343,96.65675 C5.468,99.78175 10.532,99.78175 13.657,96.65675",
    id: "Fill-4",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C9.657,6 11,4.657 11,3 C11,1.343 9.657,0 8,0 C6.343,0 5,1.343 5,3 C5,4.657 6.343,6 8,6",
    id: "Fill-6",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(164.999900, 19.000150)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#E5E6E5",
    points: "16 7.99995 11 72.99995 5 72.99995 0 7.99995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,75.99995 C9.657,75.99995 11,74.65695 11,72.99995 C11,71.34295 9.657,69.99995 8,69.99995 C6.343,69.99995 5,71.34295 5,72.99995 C5,74.65695 6.343,75.99995 8,75.99995",
    id: "Fill-8",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6573,13.65675 C16.7813,10.53275 16.7813,5.46775 13.6573,2.34375 C10.5323,-0.78125 5.4673,-0.78125 2.3433,2.34375 C0.7813,3.90575 0.000300000001,5.95275 0.000300000001,7.99975 C0.000300000001,10.04775 0.7813,12.09475 2.3433,13.65675 C5.4673,16.78175 10.5323,16.78175 13.6573,13.65675",
    id: "Fill-1",
    fill: "#00A0AF"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 11.0846154,
    x2: 235,
    y2: 11.0846154,
    id: "Path-4",
    stroke: "#979797",
    opacity: 0.251767113
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggestMoversVolume);
export default __webpack_public_path__ + "static/media/biggest-movers-volume.5c2804b8a9ddcc362205ccfb2a9afa2b.svg";
export { ForwardRef as ReactComponent };